import React, { useEffect, useRef, useContext } from 'react';
import { loadGist } from './InnerHtmlGist';
// Placeholder ID
let placeholderScriptId = 0;
const nextPlaceholderId = () => 'placeholder_script_' + placeholderScriptId++;
const Context = React.createContext({});
Context.displayName = 'InnerHtmlContext';
export const Provider = ({ children }) => {
    const p = useRef(Promise.resolve());
    function addScript(script, placeholder) {
        p.current = p.current.then(function loadScript() {
            return new Promise(function elevioAddScriptInner(res) {
                if (script.src) {
                    // Github Gist
                    if (script.src.match(/gist.github.com/)) {
                        loadGist(script.src, placeholder);
                        res();
                        return;
                    }
                    script.onload = () => res();
                    script.onerror = () => res();
                    placeholder.insertAdjacentElement('afterend', script);
                    return;
                }
                else {
                    placeholder.insertAdjacentElement('afterend', script);
                    res();
                }
            });
        });
    }
    return React.createElement(Context.Provider, { value: { addScript } }, children);
};
Provider.displayName = 'InnerHtmlProvider';
const InnerHtml = (props) => {
    const { html, ...rest } = props;
    const divRef = useRef(null);
    const scriptContext = useContext(Context);
    useEffect(() => {
        if (!html)
            return;
        // Create a 'tiny' document and parse the html string
        const slotHtml = document.createRange().createContextualFragment(html);
        // Scripts don't wait for the previous ones to load, so remove them from the document fragment
        // and manually load them ourselves.
        const scripts = slotHtml.querySelectorAll('script');
        scripts.forEach((s) => {
            var _a;
            const placeholderScript = document.createElement('script');
            placeholderScript.id = nextPlaceholderId();
            (_a = s.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(placeholderScript, s);
            scriptContext.addScript(s, placeholderScript);
        });
        // Insert custom html (without scripts)
        if (divRef.current) {
            divRef.current.innerHTML = ''; // Clear the container
            divRef.current.appendChild(slotHtml); // Append the new content
        }
    }, [html, scriptContext]);
    return React.createElement("div", Object.assign({}, rest, { ref: divRef }));
};
InnerHtml.displayName = 'InnerHtml';
export default InnerHtml;
//# sourceMappingURL=InnerHtml.js.map